<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Características equipos de monitoreo de atmósferas</h1>
      </v-flex>
      <scrolldown-app></scrolldown-app>
      <v-flex xs12 sm7 md7 class="text-xs-left">
        <span><strong>Pasos para la calibración de los equipos</strong></span>     
        <v-layout align-center class="contenido2">
          <v-flex mt-4>
        <img :src="require('../../assets/unidad2/pantalla-2-11.png')" alt="">
        </v-flex>
        <v-flex md10 mt-5>
          <p><strong>Equipo</strong></p>
        <p>Todo equipo de monitoreo de atmósferas debe ser verificado antes de su uso (bump test) y calibrado mensualmente. Revisando que el cilindro del gas patrón este vigente.</p>  
        </v-flex>
        </v-layout> 
        <v-layout align-center class="contenido2">
          <v-flex >
            <img :src="require('../../assets/unidad2/pantalla-2-12.png')" alt="">
          </v-flex>
          <v-flex md10>
            <p><strong>Persona </strong></p>
            <p>Deberá ser personal autorizado o avalado por el fabricante para la calibración. Este no deberá realizar actividades de cambio de elementos solo calibración.</p>
          </v-flex>
        </v-layout> <br> 
          <span><strong>Se debe validar cuando:</strong></span>                   
          <!-- <v-layout class="flip-item" v-for="n in 4" :key="`card-${n}`">
            <v-flex md12 xs3 justify-center align-center text-xs-center row wrap class="circulos"> 
              <img class="animated flipInY dura-1 contenido2" :src="require('../../assets/unidad2/pantalla2-'+n+'.png')" alt="">
              <span class="items" v-html="items[n-1]"></span>
              <hr class="animated bounceIn dura-3">
            </v-flex>  
          </v-layout> -->
          <v-layout wrap row  align-center text-xs-center justify-center pb-5 mt-4 class="cont_page">
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-2" src="@/assets/unidad2/pantalla2-1.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-3 text-xs-center">Si al momento de hacer la verificación, el equipo presenta error, se debe calibrar inmediatamente sin esperar que se complete el mes.</p>
                    <hr class="animated bounceIn dura-3">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-4" src="@/assets/unidad2/pantalla2-2.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-5 text-xs-center">Se golpee físicamente.</p>
                    <hr class="animated bounceIn dura-5">
                </v-flex>
                <v-flex sm12 md12></v-flex>
    
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad2/pantalla2-3.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-7 text-xs-center">Se expone a altos niveles de contaminantes (saturación).</p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-8" src="@/assets/unidad2/pantalla2-4.png" height="115" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-9 text-xs-center">Se realice monitoreo en atmósferas que contengan siliconas orgánicas, silicatos, compuestos con contenido de plomo que pueda haber desensibilizado el sensor de gas combustible y reducir la capacidad de lectura.</p>
                    <hr class="animated bounceIn dura-9">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-8" src="@/assets/unidad2/pantalla2-7.png" height="115" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-9 text-xs-center">Cada vez que presenta algún error en la prueba funcional o de verificación.</p>
                    <hr class="animated bounceIn dura-9">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-10" src="@/assets/unidad2/pantalla2-5.png" height="120" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-11 text-xs-center">Otras consideraciones estipuladas por el fabricante en el manual de uso del equipo.</p>
                    <hr class="animated bounceIn dura-11">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-12" src="@/assets/unidad2/pantalla2-2.png" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-13 text-xs-center">Cuando se presenta deterioro en los visores o estructura física del equipo.</p>
                    <hr class="animated bounceIn dura-13">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md12 class="text-xs-center">
                    <img class="animated bounceIn dura-12" src="@/assets/unidad2/pantalla2-6.png" height="115" alt="">
                </v-flex>
                <v-flex xs12 sm9 md12>
                    <p class="animated bounceIn dura-13 text-xs-center">Con una frecuencia mínima mensual.</p>
                    <hr class="animated bounceIn dura-13">
                </v-flex>
                <v-flex sm12 md12></v-flex>
            </v-layout>
          
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      length:10, 
      onboarding: 0,
      vistos:Array(10).fill(false), 
      dialogos: [
        '' 
      ],
      texto:[
        'Debe ser <strong>intrínsecamente seguro.</strong> Clase I, División I, Grupos A,B,C,D. <br> Un equipo intrínsecamente seguro es el que <strong>es incapaz de descargar una energía eléctrica o térmica suficiente, en condiciones normales o anormales,</strong> para provocar la ignición de mezclas atmosféricas específicamente peligrosas.',
        'Debe tener protección contra la interferencia electromagnética (EMI) y la interferencia por radiofrecuencia (RFI).',
        'Debe visualizar datos en pantalla con la concentración del gas (%O2, %LEL, CO ppm, H2S ppm y otros gases que apliquen según el sensor instalado) en pantalla auto-iluminada.',
        'Debe disponer de alarma sonora, fácilmente audible (mínimo 85 dB) y visual.',
        'Debe tener una clasificación IP65 (resistente al polvo y la humedad).',
        'Operable en condiciones de temperatura entre -10°C y 40 °C y humedad relativa de 15% a 90%.',
        'Contar con memoria para almacenamiento de datos registrados de gases inflamables, oxígeno y tóxicos, y permitir la impresión de estos.',
        'Que requiera calibración/verificación usando un gas patrón.',
        'Los equipos deberán contar con módulo de bombeo (generación de vacío), sensores para cada uno de los gases que se van a detectar, tubo toma muestra con su manguera para situaciones donde no se puede acceder o se tenga alto riesgo de inhalación de vapores, filtros para retener material particulado y/o humedad.',
        'Debe tener asistencia técnica y mantenimiento en Colombia, con programa de disposición de residuos peligrosos.'
      ],
      items:[
        'Si al momento de hacer la verificación, el equipo presenta error, se debe calibrar inmediatamente sin esperar que se complete el mes.',
        'Cuando se golpee físicamente.',
        'Cuando se expone a altos niveles de contaminantes.',
        'Cuando se realice prueba de gases en atmósferas que contengan siliconas orgánicas, silicatos, compuestos con contenido de plomo que pueda haber desensibilizado el sensor de gas combustible y reducir la capacidad de lectura.'
      ],

    }
  },
    created() {
    this.$set(this.vistos,0,true)
  },
  mounted(){
    setTimeout(() => {
      this.$store.commit('nextShow', true)
    }, 7000);
  }

}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 15px;
    height: 15px;
  }
}
.flip-item{
  position: relative;
  width: 100%;
  height:auto;
  padding: 10px;
  p{
    text-align: center;
  }
  .pb{
    color: $color-secondary;
    font-family: FontBase-Bold;
  }
  @media screen and (max-width: 330px) {
    img{
      width: 80px;
    }
    
  }
}
.caja_texto{
  background:#ffff;
  padding: 5px 5px 5px 5px;
}
hr {
    height: 2px;
    background-color: $color-complement-one;
    border: none;
    margin-bottom: 1em;
}
@media screen and (max-width: 500px){
.contenido2{
  display: flex;
  flex-direction: column;
  align-items: center;
}
}
.circulos{
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
